<template>
  <button v-if="countdown === 0" class="weui-vcode-btn" @click="getLoginSmsCode">发送验证码</button>
  <span v-else class="weui-vcode-btn counting-down">{{ countdown }}秒后重发</span>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from 'weui.js';
import { REQUEST_SMS_CODE } from '@/store/auth/types';

const { mapState, mapActions } = createNamespacedHelpers('auth');

export default {
    props: {
        phone: {
            type: String,
            default: null,
        },
        captcha: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapState([
            'countdown',
        ]),
    },
    methods: {
        ...mapActions({
            apiRequestSmsCode: REQUEST_SMS_CODE,
        }),
        getLoginSmsCode() {
            if (!this.phone) {
                weui.toast('手机号码不能为空');
                return;
            }
            if (!this.captcha) {
                weui.toast('验证码不能为空');
                return;
            }
            this.apiRequestSmsCode({
                phone: this.phone,
                captcha: this.captcha,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import './../../assets/scss/variables';

.counting-down {
    color: $weuiTextColorGray;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/VcodeButton.vue